export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/jan-sendereks-04f0390102a515ab4bb092d34f01eed8.jpg";